<template>
  <el-tag :type="tagType" size="small">{{ label }}</el-tag>
</template>

<script>
const labelMap = {
  active: "正常",
  inactive: "停用/隐藏",
  pending: "待处理",
  following: "跟进中",
  assigned: "已分配",
  planning: "规划中",
  processing: "处理中",
  pending_trip: "待出行",
  traveling: "出行中",
  completed: "已完成",
  closed: "已关闭",
  cancelled: "已取消",
  approved: "已通过",
  rejected: "已拒绝",
  hidden: "已隐藏",
  enabled: "已启用",
  disabled: "已禁用",
  paid: "已支付",
  unpaid: "未支付",
  refunded: "已退款"
};

export default {
  name: "StatusTag",
  props: {
    value: { type: String, default: "" }
  },
  computed: {
    label() {
      return labelMap[this.value] || this.value || "未设置";
    },
    tagType() {
      if (this.value === "active" || this.value === "completed" || this.value === "approved" || this.value === "paid" || this.value === "enabled") return "success";
      if (this.value === "inactive" || this.value === "hidden" || this.value === "cancelled" || this.value === "refunded" || this.value === "closed" || this.value === "disabled") return "info";
      if (this.value === "pending" || this.value === "following" || this.value === "assigned" || this.value === "planning" || this.value === "processing" || this.value === "unpaid" || this.value === "pending_trip" || this.value === "traveling") return "warning";
      if (this.value === "rejected") return "danger";
      return "";
    }
  }
};
</script>
